<template>
  <div>
    <h3 v-if="!showAddCard">Payment Methods</h3>

    <div v-if="!paymentMethods.length" class="mb-3">
      No payment methods on file.
    </div>

    <b-table-lite
      v-else-if="!showAddCard"
      :items="paymentMethods"
      :fields="fields"
      responsive="sm"
      striped
    >
      <template #cell(default)="{ item }">
        <b-form-radio
          v-model="defaultCard"
          @change="selectCard(item.id)"
          :value="item.id"
        >
          <b>{{ item.brand }}</b> ending in {{ item.last4 }}
        </b-form-radio>
      </template>

      <template #cell(expiry)="{ item }">
        {{ item.exp_month }} / {{ item.exp_year }}
      </template>

      <template #cell(remove)="{ item }">
        <b-btn @click="removeCard(item.id)" variant="link" class="p-0">
          <i class="icon-close"></i>
        </b-btn>
      </template>
    </b-table-lite>

    <b-btn v-if="!showAddCard" @click="showAddCard = true" variant="primary">
      Add Card
    </b-btn>

    <template v-else>
      <checkout
        ref="checkout"
        :hideSubmit="true"
        @validationChange="validCard = $event"
        @success="addCard"
      ></checkout>

      <NanInput
        v-model="makeDefault"
        type="checkbox"
        label="Make this my default payment method"
        class="mb-3"
      />

      <b-btn @click="showAddCard = false" variant="light" class="mr-2">
        Cancel
      </b-btn>

      <b-btn @click="getStripeToken" :disabled="!validCard" variant="primary">
        Submit
      </b-btn>
    </template>
  </div>
</template>

<script>
import API from "@/api";
import Checkout from "@/components/Checkout";
import { mapState } from "vuex";

export default {
  components: {
    Checkout
  },

  data: () => ({
    fields: [
      { key: "default", label: "Default Card" },
      { key: "expiry", label: "Expires on", class: "text-center" },
      { key: "remove", label: "Remove", class: "text-center" }
    ],
    validCard: false,
    makeDefault: true,
    paymentMethods: [],
    defaultCard: null,
    defaultCardPrev: null,
    showAddCard: false
  }),

  computed: {
    ...mapState("billing", ["methods"])
  },

  watch: {
    methods(methods) {
      this.paymentMethods = methods.list;
      this.defaultCard = methods.current ? methods.current.id : null;
      this.defaultCardPrev = this.defaultCard;
    }
  },

  methods: {
    async getStripeToken() {
      this.$refs.checkout.onSubmit();
    },

    async addCard(data) {
      this.$store.commit("REQUEST_INCREMENT");
      await API.addPaymentMethod(data.tokenId);

      if (this.makeDefault) {
        await API.selectPaymentMethod(data.cardInfo.id);
      }

      await this.$store.dispatch("billing/methods");

      this.showAddCard = false;
      this.$store.commit("REQUEST_DECREMENT");
    },

    async removeCard(id) {
      const confirm = await this.$bvModal.msgBoxConfirm(
        "Are you sure you want to remove this card?",
        {
          title: "Remove Payment Method",
          okTitle: "Yes",
          okVariant: "danger",
          size: "sm",
          centered: true
        }
      );

      if (!confirm) return;

      this.$store.commit("REQUEST_INCREMENT");
      await API.removePaymentMethod(id);
      await this.$store.dispatch("billing/methods");
      this.$store.commit("REQUEST_DECREMENT");
    },

    async selectCard(id) {
      const confirm = await this.$bvModal.msgBoxConfirm(
        "Future license renewals and purchases will use the selected card",
        {
          title: "Change Payment Method",
          size: "sm",
          centered: true
        }
      );

      if (!confirm) {
        this.defaultCard = this.defaultCardPrev;
        return;
      }

      this.$store.commit("REQUEST_INCREMENT");
      await API.selectPaymentMethod(id);
      await this.$store.dispatch("billing/methods");
      this.$store.commit("REQUEST_DECREMENT");
    }
  }
};
</script>
